import {
  GET_ALL_PARTNERS,
  GET_ALL_PARTNERS_SUCCESS,
  GET_ALL_PARTNERS_FAILED,
  GET_ALL_PRODUCT_TYPES,
  GET_ALL_PRODUCT_TYPES_SUCCESS,
  GET_ALL_PRODUCT_TYPES_FAILED,
  GET_ED_ORDERS_SUMMARY,
  GET_ED_ORDERS_SUMMARY_SUCCESS,
  GET_ED_ORDERS_SUMMARY_FAILED,
  RESET_ED_ORDERS_SUMMARY,
} from "../actions";

export const initialState = {
  partners: {
    loading: false,
    data: [],
    error: null,
  },

  productTypes: {
    loading: false,
    data: [],
    error: null,
  },

  edOrdersSummary: {
    loading: false,
    data: [],
    error: null,
  },
};

export function EdOrdersSummaryReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_PARTNERS: {
      return {
        ...state,
        partners: {
          loading: true,
          data: [],
          error: null,
        },
      };
    }
    case GET_ALL_PARTNERS_SUCCESS: {
      return {
        ...state,
        partners: {
          loading: false,
          data: action?.payload,
          error: null,
        },
      };
    }
    case GET_ALL_PARTNERS_FAILED:
      return {
        ...state,
        partners: {
          loading: false,
          data: [],
          error: action?.error,
        },
      };

    case GET_ALL_PRODUCT_TYPES: {
      return {
        ...state,
        productTypes: {
          loading: true,
          data: [],
          error: null,
        },
      };
    }
    case GET_ALL_PRODUCT_TYPES_SUCCESS: {
      return {
        ...state,
        productTypes: {
          loading: false,
          data: action?.payload,
          error: null,
        },
      };
    }
    case GET_ALL_PRODUCT_TYPES_FAILED:
      return {
        ...state,
        productTypes: {
          loading: false,
          data: [],
          error: action?.error,
        },
      };
    case GET_ED_ORDERS_SUMMARY: {
      return {
        ...state,
        edOrdersSummary: {
          loading: true,
          data: [],
          error: null,
        },
      };
    }
    case GET_ED_ORDERS_SUMMARY_SUCCESS: {
      return {
        ...state,
        edOrdersSummary: {
          loading: false,
          data: action?.payload,
          error: null,
        },
      };
    }
    case GET_ED_ORDERS_SUMMARY_FAILED:
      return {
        ...state,
        edOrdersSummary: {
          loading: false,
          data: [],
          error: action?.error,
        },
      };
    case RESET_ED_ORDERS_SUMMARY:
      return {
        ...state,
        edOrdersSummary: {
          loading: false,
          data: [],
          error: null,
        },
      };

    default:
      return state;
  }
}

export default EdOrdersSummaryReducer;
